import React from 'react'
import { Stack, Skeleton, StackProps, SkeletonProps, Box, Divider } from '@mui/material'

export interface ListSkeletonWrapperProps extends StackProps {
  children: React.ReactNode
  count?: number
}

const Wrapper = ({ children, count = 3, ...props }: ListSkeletonWrapperProps) => {
  return (
    <Stack spacing={2} width="100%" direction="column" {...props}>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>
          {children}
        </React.Fragment>
      ))}
    </Stack>
  )
}

const Circle = ({ sx, ...props }: SkeletonProps) => {
  return <Skeleton variant="circular" width={48} height={48} sx={{ flexShrink: 0, ...sx }} {...props} />
}

const Rectangle = ({ sx, ...props }: SkeletonProps) => {
  return <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2, ...sx }} {...props} />
}

const Card = ({ height = 110, children }: { height?: number | string; children?: React.ReactNode }) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 3,
      p: 2.5,
      width: '100%',
      minHeight: height,
    }}
  >
    {children || <Skeleton variant="text" width="60%" />}
  </Box>
)

const PaymentItem = () => (
  <Card height={90}>
    <Stack direction="row" spacing={2} alignItems="center">
      <Circle width={48} height={48} />
      <Stack spacing={1} flex={1}>
        <Skeleton variant="text" width="40%" height={20} />
        <Skeleton variant="text" width="60%" height={15} />
      </Stack>
      <Skeleton variant="text" width="20%" height={24} />
    </Stack>
  </Card>
)

const HistoryItem = () => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 3,
      overflow: 'hidden',
      width: '100%',
      minHeight: 300,
    }}
  >
    <Skeleton variant="rectangular" width="100%" height={24} />
    <Box p={5}>
      <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
        <Circle width={40} height={40} />
        <Stack spacing={0.5} flex={1}>
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="40%" height={16} />
        </Stack>
      </Stack>
      <Stack direction="row" spacing={1} mb={2}>
        <Skeleton variant="rounded" width="33%" height={50} />
        <Skeleton variant="rounded" width="33%" height={50} />
        <Skeleton variant="rounded" width="33%" height={50} />
      </Stack>
      <Divider />
      <Box pt={1.5} display="flex" justifyContent="center">
        <Skeleton variant="text" width="30%" height={20} />
      </Box>
    </Box>
  </Box>
)

export const ListSkeleton = {
  Wrapper,
  Circle,
  Rectangle,
  Card,
  PaymentItem,
  HistoryItem,
}
